import { useRouteMatch } from 'react-router-dom';
import { QueryKey } from 'react-query';

import { IS_DEV } from '../../lib/config';
import { extractUrlDetails } from '../routing';

const setQueryKey = (queryKey: QueryKey) => {
  if (!IS_DEV) {
    const { url } = useRouteMatch();
    const { appId } = extractUrlDetails(url);
    if (!Array.isArray(queryKey)) {
      queryKey = [queryKey, appId];
    } else {
      queryKey = [...queryKey, appId];
    }
  }
  return queryKey;
};

export default setQueryKey;
